import React from 'react';
import SimpleDailyTaskEditor from './SimpleDailyTaskEditor';
import './DailyTaskReport.css';

interface DailyTask {
  id: string;
  date: string;
  particulars: string;
  remarks: string;
  userId: string;
  userName: string;
  createdAt: Date;
  updatedAt: Date;
}

interface DailyTaskReportProps {
  isAdmin?: boolean;
  selectedUserId?: string;
  selectedUserName?: string;
}

const DailyTaskReport: React.FC<DailyTaskReportProps> = ({ 
  isAdmin = false, 
  selectedUserId, 
  selectedUserName 
}) => {
  return (
    <SimpleDailyTaskEditor
      isAdmin={isAdmin}
      selectedUserId={selectedUserId}
      selectedUserName={selectedUserName}
    />
  );
};

export default DailyTaskReport;
